module.exports = __webpack_public_path__ + "img/inter_roll_call.e8f6fe6c.svg";